<template>
<div>
    <router-link :to="{ name: 'collective_gateway_details', params: { hashid: row.id }}" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
        <span class="tooltip-text">{{ $t('btn.edit') + ' ' + $t('psp.' + row.psp) }}</span>
        <i class="fa fa-edit"></i>
    </router-link>
    <router-link :to="{ name: 'collective_gateway_online_transaction', params: { hashid: row.id } ,query:{psp : row.psp}}" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
        <span class="tooltip-text">{{ $t('btn.getTransactionReport') + ' ' + $t('psp.' + row.psp) }}</span>
        <i class="fa fa-chart-line"></i>
    </router-link>
    <router-link :to="{ name: 'collective_gateway_offline_transaction', params: { hashid: row.id } ,query:{psp : row.psp}}" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
        <span class="tooltip-text">{{ $t('btn.getStatementsReport') + ' ' + $t('psp.' + row.psp) }}</span>
        <i class="fa fa-database"></i>
    </router-link>
    <div v-if="row.status !== gatewayStatus.ARCHIVE" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
        <span class="tooltip-text">{{ $t('btn.archive') }}</span>
        <i v-on:click="archiveGateway(row.id)" :id="'archive_btn_'+row.id" class="fa fa-archive"></i>
    </div>
</div>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import {i18n} from "@/plugins/i18n";
import {KTApp} from "@/plugins/core/app";
import {collectiveService} from "@/common/api.service";
import {mapGetters} from "vuex";
import toastr from "toastr";
import { gatewayStatus } from '@/constants/gatewayStatus'

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    data () {
        return {
            gatewayStatus: gatewayStatus
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },
    methods : {
        archiveGateway(hashid) {
            if(confirm(i18n.t('confirm.archive_gateway'))) {
                let btn = $('#archive_btn_' + hashid)

                KTApp.progress(btn)
                collectiveService.deleteGateway(hashid)
                    .then(response => {
                        this.datatable.reload()
                        this.toastr.success(response.data.message);
                    })
                    .catch(({response}) => {
                        this.toastr.error(response.data.message);
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
            }
        },
    },
})
</script>

<style>

.special-tooltip{
    position: relative;
    display: inline-block;
}
.special-tooltip .tooltip-text {
    visibility: hidden;
    background-color: #555;
    color: #fff;
    text-align: center;
    padding: 5px 10px;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    opacity: 0;
    transition: opacity 0.3s;
    min-width: 90px !important;
}
.special-tooltip .tooltip-text::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    /*margin-left: -5px;*/
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
}
.special-tooltip:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}
.color-novin{
    color: #683f84;
}
.color-mellat{
    color: #ed1b2f;
}
.color-saman{
    color: #07abea;
}
.color-parsian{
    color: #9c0f1e;
}
.color-pasargad{
    color: #f7a801;
}
.psp_logo{
    margin: auto;
    margin-top: 30px;
    width: 55px;
    height: 55px;
    transform: translate(0, -50%);
}
</style>